import script from "./BaseInfoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInfoDetail.vue?vue&type=script&setup=true&lang=js"

import "./BaseInfoDetail.vue?vue&type=style&index=0&id=7a567cbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a567cbd"]])

export default __exports__